import type { FC } from "react";
import { AccentIconTile } from "@/ui/molecules/AccentIconTile";
import type { LedgerEntry } from "@/utils/models";
import { entryTileLook, ORIGIN_KIND_ICON } from "./requestOriginMeta";

/** One entry's tile: the kind's glyph, toned by what it was — an opening's group, a removal's neutral, no recorded cause outlined. */
export const RequestOriginTile: FC<{ entry: LedgerEntry }> = ({ entry }) => {
	const Icon = ORIGIN_KIND_ICON[entry.kind];
	const { tone, dashed } = entryTileLook(entry);
	return (
		<AccentIconTile size="xs" tone={tone} dashed={dashed}>
			<Icon />
		</AccentIconTile>
	);
};
